<template>
  <v-layout>
    <v-flex>
      <v-data-table
        :headers="headers"
        :items="quedans"
        :search="search"
        class="elevation-1"
        v-if="verNuevo == 0"
      >
        <template v-slot:top>
          <v-toolbar elevation="0">
            <v-toolbar-title>Quedan</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  outlined
                  icon
                  color="green"
                  v-bind="attrs"
                  v-on="on"
                  @click="listarQuedans()"
                  ><v-icon class="fa fa-sync-alt"></v-icon
                ></v-btn>
              </template>
              <span>Actualizar tabla</span>
            </v-tooltip>
            <v-col cols="auto">
              <v-menu
                :close-on-content-click="false"
                :nudge-width="200"
                offset-x
                transition="scale-transition"
                v-if="verNuevo == 0"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn color="primary" dark v-bind="attrs" v-on="on">
                    Opciones
                  </v-btn>
                </template>
                <v-card>
                  <v-card-title class="py-0 mx-0"
                    >Fitrar por fechas</v-card-title
                  >
                  <v-list class="py-0">
                    <v-list-item>
                      <v-text-field
                        hide-details
                        type="date"
                        label="Desde"
                        v-model="fechaInicio"
                        :max="new Date().toISOString().substr(0, 10)"
                        clearable
                      ></v-text-field>
                    </v-list-item>
                    <v-list-item>
                      <v-text-field
                        hide-details
                        type="date"
                        label="Desde"
                        v-model="fechaFin"
                        :max="new Date().toISOString().substr(0, 10)"
                        clearable
                      ></v-text-field>
                    </v-list-item>
                    <v-list-item>
                      <v-btn color="primary" dark @click="listarxFechas()"
                        >Filtrar</v-btn
                      >
                    </v-list-item>
                  </v-list>
                </v-card>
              </v-menu>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="4">
              <v-text-field
                class="text-xs-center"
                v-model="search"
                append-icon="search"
                label="Busqueda"
                single-line
                hide-details
              ></v-text-field>
            </v-col>
            <v-spacer></v-spacer>
            <v-btn color="primary" class="ml-5" @click="VerNuevo()"
              >Nuevo</v-btn
            >
          </v-toolbar>
        </template>
        <template v-slot:[`item.action`]="{ item }">
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                small
                class="mr-2"
                @click="verDetalles(item)"
                v-bind="attrs"
                v-on="on"
              >
                tab
              </v-icon>
            </template>
            <span>Editar</span>
          </v-tooltip>
        </template>
      </v-data-table>

      <v-overlay v-model="overlay" z-index="1">
        <lottie-player
          autoplay
          loop
          mode="normal"
          src="https://assets5.lottiefiles.com/datafiles/XpFCWApEzLI29va/data.json"
          style="width: 320px"
        >
        </lottie-player>
      </v-overlay>

      <v-snackbar v-model="snackMensajeFechas" color="cyan darken-2" top
        >Debe de seleccionar ambas fechas.</v-snackbar
      >
      <v-snackbar v-model="snackError" color="yellow darken-3" top
        >Hubo un error, verificar conexión o recargar la pagina.</v-snackbar
      >

      <v-row v-if="verNuevo == 1 || verDet == 1" no-gutters>
        <v-col cols="12" class="pa-0">
          <v-toolbar elevation="1">
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="cerrarNuevo()" v-if="verNuevo == 1"
              >Cerrar</v-btn
            >
            <v-btn
              color="primary"
              @click="imprimir()"
              class="ml-5"
              v-if="verNuevo == 1"
              >Imprimir</v-btn
            >
            <v-btn
              color="primary"
              class="ml-5"
              @click="crearQuedan()"
              v-if="verDet == 0"
              >Guardar</v-btn
            >
            <v-btn
              color="primary"
              class="ml-5"
              @click="actualizarQuedan()"
              v-if="verDet == 1"
              >Actualizar</v-btn
            >
          </v-toolbar>
        </v-col>
        <vue-html2pdf
          :show-layout="true"
          :float-layout="false"
          :enable-download="false"
          :preview-modal="true"
          :paginate-elements-by-height="1400"
          filename="F1"
          :pdf-quality="2"
          :manual-pagination="false"
          pdf-format="a4"
          pdf-orientation="portrait"
          pdf-content-width="792px"
          @hasStartedGeneration="hasStartedGeneration()"
          @hasGenerated="hasGenerated($event)"
          ref="html2Pdf"
          class="mx-auto"
        >
          <section slot="pdf-content">
            <v-col cols="12">
              <v-row no-gutters>
                <!-- LOGO Y CONTACTOS -->
                <v-col cols="6">
                  <v-card
                    max-width="792"
                    height="120"
                    elevation="0"
                    style="
                      margin-left: 25px;
                      margin-right: 25px;
                      margin-top: 25px;
                      z-index: 2;
                    "
                  >
                    <v-img
                      :src="require('@/assets/logoAR_transparency.png')"
                      max-height="180"
                      max-width="180"
                      style="position: absolute; left: 5px; bottom: 1px"
                    ></v-img>
                    <v-row class="ma-0">
                      <v-col cols="auto" class="textContactoNombre">
                        <div>ASISTENCIA REGIONAL EL SALVADOR, S.A DE C.V.</div>
                      </v-col>
                    </v-row>
                    <v-row class="ma-0">
                      <v-col cols="auto" class="textContactoDireccionTelefono">
                        <div>Prolongacion 87 av. Sur, Colonia Maquilishuat</div>
                      </v-col>
                    </v-row>
                    <v-row class="ma-0">
                      <v-col cols="auto" class="textContactoDireccionTelefono">
                        <div>#4, San Salvador, El Salvador</div>
                      </v-col>
                    </v-row>
                    <v-row class="ma-0">
                      <v-col cols="auto" class="textContactoDireccionTelefono">
                        <div>PBX (503) 2508-4000</div>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
                <!-- FECHA Y CORRELATIVO -->
                <v-col cols="6">
                  <v-card
                    max-width="792"
                    height="120"
                    elevation="0"
                    style="
                      margin-left: 25px;
                      margin-right: 25px;
                      margin-top: 25px;
                      margin-bottom: 48px;
                    "
                  >
                    <v-row class="ma-0">
                      <v-col cols="12">
                        <table class="table_1">
                          <tr>
                            <th>Fecha emisión</th>
                            <td>
                              <v-text-field
                                v-model="fechaEmision"
                                hide-details
                                dense
                                height="15"
                                type="datetime-local"
                                class="textFieldStyle"
                                v-if="flag"
                              ></v-text-field>
                              <v-text-field
                                v-model="fechaEmision"
                                hide-details
                                dense
                                height="15"
                                class="textFieldStyle"
                                v-else
                              ></v-text-field>
                            </td>
                          </tr>
                          <tr>
                            <th>Fecha de pago</th>
                            <td>
                              <v-text-field
                                v-model="fechaPago"
                                hide-details
                                dense
                                height="15"
                                type="datetime-local"
                                step="1"
                                class="textFieldStyle"
                                v-if="flag"
                              ></v-text-field>
                              <v-text-field
                                v-model="fechaPago"
                                hide-details
                                dense
                                height="15"
                                step="1"
                                class="textFieldStyle"
                                v-else
                              ></v-text-field>
                            </td>
                          </tr>
                          <tr>
                            <th>Quedan N°</th>
                            <td>
                              <v-text-field
                                v-model="correlativoQuedan"
                                hide-details
                                dense
                                height="15"
                                class="textFieldStyle"
                              ></v-text-field>
                            </td>
                          </tr>
                          <tr>
                            <th>Folio N°</th>
                            <td>
                              <v-text-field
                                v-model="correlativoFolio"
                                hide-details
                                dense
                                height="15"
                                @keypress.enter="getVentaTotalFolio"
                                class="textFieldStyle"
                              ></v-text-field>
                            </td>
                          </tr>
                        </table>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
              </v-row>

              <!-- TABLA 2 -->
              <v-card max-width="792" height="auto" elevation="0">
                <v-row
                  class="ma-1"
                  style="padding-left: 25px; padding-right: 25px"
                >
                  <v-col cols="12">
                    <table class="table_2">
                      <tr>
                        <th>A favor de</th>
                        <td colspan="5">
                          <v-text-field
                            v-model="aFavorDe"
                            hide-details
                            dense
                            height="15"
                            class="textFieldStyle"
                          ></v-text-field>
                        </td>
                      </tr>
                      <tr>
                        <th>Razón social</th>
                        <td colspan="5">
                          <v-text-field
                            v-model="razonSocial"
                            hide-details
                            dense
                            height="15"
                            class="textFieldStyle"
                          ></v-text-field>
                        </td>
                      </tr>
                      <tr>
                        <th>NCR Proveedor</th>
                        <td colspan="2">
                          <v-text-field
                            v-model="ncrProveedor"
                            hide-details
                            dense
                            height="15"
                            class="textFieldStyle"
                          ></v-text-field>
                        </td>
                        <th>DUI Proveedor</th>
                        <td colspan="2">
                          <v-text-field
                            v-model="duiProveedor"
                            hide-details
                            dense
                            height="15"
                            class="textFieldStyle"
                            @change="infoproveedores()"
                          ></v-text-field>
                        </td>
                      </tr>
                      <td colspan="6" style="text-align: center">
                        Datos Crédito Fiscal
                      </td>
                      <tr>
                        <th>No. FAC</th>
                        <td>
                          <v-text-field
                            v-model="nFac_1"
                            hide-details
                            dense
                            height="15"
                            class="textFieldStyle"
                          ></v-text-field>
                        </td>
                        <td>
                          <v-text-field
                            v-model="nFac_2"
                            hide-details
                            dense
                            height="15"
                            class="textFieldStyle"
                          ></v-text-field>
                        </td>
                        <td>
                          <v-text-field
                            v-model="nFac_3"
                            hide-details
                            dense
                            height="15"
                            class="textFieldStyle"
                          ></v-text-field>
                        </td>
                        <th>Monto en dólares</th>
                        <td>
                          <v-text-field
                            v-model="montoDolares"
                            hide-details
                            dense
                            height="15"
                            class="textFieldStyle"
                            @change="conversionNumero()"
                          ></v-text-field>
                        </td>
                      </tr>
                      <tr>
                        <th>Banco</th>
                        <td colspan="2">
                          <v-text-field
                            v-model="nombre_banco"
                            hide-details
                            dense
                            height="15"
                            class="textFieldStyle"
                          ></v-text-field>
                        </td>
                        <th>N° de Cuenta</th>
                        <td colspan="3">
                          <v-text-field
                            v-model="numero_cuenta"
                            hide-details
                            dense
                            height="15"
                            class="textFieldStyle"
                          ></v-text-field>
                        </td>
                      </tr>
                      <tr>
                        <th>Cantidad en letras</th>
                        <td colspan="5">
                          <v-text-field
                            v-model="cantidadLetras"
                            hide-details
                            dense
                            height="15"
                            class="textFieldStyle body-2"
                          ></v-text-field>
                        </td>
                      </tr>
                    </table>
                  </v-col>
                </v-row>
              </v-card>

              <!-- FIRMAS -->
              <v-card max-width="792" height="auto" elevation="0">
                <v-row
                  class="ma-1"
                  style="
                    justify-content: space-between;
                    padding-left: 25px;
                    padding-right: 25px;
                  "
                >
                  <v-col cols="3.5">
                    <v-text-field hide-details></v-text-field>
                  </v-col>
                  <v-col cols="3.5">
                    <v-text-field hide-details></v-text-field>
                  </v-col>
                </v-row>
                <v-row
                  class="ma-1"
                  style="
                    justify-content: space-between;
                    padding-left: 25px;
                    padding-right: 25px;
                  "
                >
                  <v-col cols="3.5">
                    <div style="text-align: center">Firma de elaborado</div>
                  </v-col>
                  <v-col cols="3.5">
                    <div style="text-align: center">Firma recibido</div>
                  </v-col>
                </v-row>
              </v-card>

              <!-- seccion 1 -->
              <v-row class="ma-0 styleFecha">
                <v-col cols="auto"> ORIGINAL </v-col>
              </v-row>
            </v-col>

            <v-img
              :src="require('@/assets/dotted-line.png')"
              width="800"
              height="1"
            ></v-img>

            <v-col cols="12">
              <v-row no-gutters>
                <!-- LOGO Y CONTACTOS -->
                <v-col cols="6">
                  <v-card
                    max-width="792"
                    height="150"
                    elevation="0"
                    style="
                      margin-left: 25px;
                      margin-right: 25px;
                      margin-top: 25px;
                      z-index: 2;
                    "
                  >
                    <v-img
                      :src="require('@/assets/logoAR_transparency.png')"
                      max-height="180"
                      max-width="180"
                      style="position: absolute; left: 5px; bottom: 1px"
                    ></v-img>
                    <v-row class="ma-0">
                      <v-col cols="auto" class="textContactoNombre">
                        <div>ASISTENCIA REGIONAL EL SALVADOR, S.A DE C.V.</div>
                      </v-col>
                    </v-row>
                    <v-row class="ma-0">
                      <v-col cols="auto" class="textContactoDireccionTelefono">
                        <div>Prolongacion 87 av. Sur, Colonia Maquilishuat</div>
                      </v-col>
                    </v-row>
                    <v-row class="ma-0">
                      <v-col cols="auto" class="textContactoDireccionTelefono">
                        <div>#4, San Salvador, El Salvador</div>
                      </v-col>
                    </v-row>
                    <v-row class="ma-0">
                      <v-col cols="auto" class="textContactoDireccionTelefono">
                        <div>PBX (503) 2508-4000</div>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
                <!-- FECHA Y CORRELATIVO -->
                <v-col cols="6">
                  <v-card
                    max-width="792"
                    height="150"
                    elevation="0"
                    style="
                      margin-left: 25px;
                      margin-right: 25px;
                      margin-top: 25px;
                    "
                  >
                    <v-row class="ma-0">
                      <v-col cols="12">
                        <table class="table_1">
                          <tr>
                            <th>Fecha emisión</th>
                            <td>
                              <v-text-field
                                v-model="fechaEmision"
                                hide-details
                                dense
                                height="15"
                                class="textFieldStyle"
                              ></v-text-field>
                            </td>
                          </tr>
                          <tr>
                            <th>Fecha de pago</th>
                            <td>
                              <v-text-field
                                v-model="fechaPago"
                                hide-details
                                dense
                                height="15"
                                class="textFieldStyle"
                              ></v-text-field>
                            </td>
                          </tr>
                          <tr>
                            <th>Quedan N°</th>
                            <td>
                              <v-text-field
                                v-model="correlativoQuedan"
                                hide-details
                                dense
                                height="15"
                                class="textFieldStyle"
                              ></v-text-field>
                            </td>
                          </tr>
                          <tr>
                            <th>Folio N°</th>
                            <td>
                              <v-text-field
                                v-model="correlativoFolio"
                                hide-details
                                dense
                                height="15"
                                class="textFieldStyle"
                              ></v-text-field>
                            </td>
                          </tr>
                        </table>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
              </v-row>

              <!-- TABLA 2 -->
              <v-card max-width="792" height="auto" elevation="0">
                <v-row
                  class="ma-1"
                  style="padding-left: 25px; padding-right: 25px"
                >
                  <v-col cols="12">
                    <table class="table_2">
                      <tr>
                        <th>A favor de</th>
                        <td colspan="5">
                          <v-text-field
                            v-model="aFavorDe"
                            hide-details
                            dense
                            height="15"
                            class="textFieldStyle"
                          ></v-text-field>
                        </td>
                      </tr>
                      <tr>
                        <th>Razón social</th>
                        <td colspan="5">
                          <v-text-field
                            v-model="razonSocial"
                            hide-details
                            dense
                            height="15"
                            class="textFieldStyle"
                          ></v-text-field>
                        </td>
                      </tr>
                      <tr>
                        <th>NCR Proveedor</th>
                        <td colspan="2">
                          <v-text-field
                            v-model="ncrProveedor"
                            hide-details
                            dense
                            height="15"
                            class="textFieldStyle"
                          ></v-text-field>
                        </td>
                        <th>DUI Proveedor</th>
                        <td colspan="2">
                          <v-text-field
                            v-model="duiProveedor"
                            hide-details
                            dense
                            height="15"
                            class="textFieldStyle"
                            @change="infoproveedores()"
                          ></v-text-field>
                        </td>
                      </tr>
                      <td colspan="6" style="text-align: center">
                        Datos Crédito Fiscal
                      </td>
                      <tr>
                        <th>No. FAC</th>
                        <td>
                          <v-text-field
                            v-model="nFac_1"
                            hide-details
                            dense
                            height="15"
                            class="textFieldStyle"
                          ></v-text-field>
                        </td>
                        <td>
                          <v-text-field
                            v-model="nFac_2"
                            hide-details
                            dense
                            height="15"
                            class="textFieldStyle"
                          ></v-text-field>
                        </td>
                        <td>
                          <v-text-field
                            v-model="nFac_3"
                            hide-details
                            dense
                            height="15"
                            class="textFieldStyle"
                          ></v-text-field>
                        </td>
                        <th>Monto en dólares</th>
                        <td>
                          <v-text-field
                            v-model="montoDolares"
                            hide-details
                            dense
                            height="15"
                            class="textFieldStyle"
                          ></v-text-field>
                        </td>
                      </tr>
                      <tr>
                        <th>Banco</th>
                        <td colspan="2">
                          <v-text-field
                            v-model="nombre_banco"
                            hide-details
                            dense
                            height="15"
                            class="textFieldStyle"
                          ></v-text-field>
                        </td>
                        <th>N° de Cuenta</th>
                        <td colspan="3">
                          <v-text-field
                            v-model="numero_cuenta"
                            hide-details
                            dense
                            height="15"
                            class="textFieldStyle"
                          ></v-text-field>
                        </td>
                      </tr>
                      <tr>
                        <th>Cantidad en letras</th>
                        <td colspan="5">
                          <v-text-field
                            v-model="cantidadLetras"
                            hide-details
                            dense
                            height="15"
                            class="textFieldStyle body-2"
                          ></v-text-field>
                        </td>
                      </tr>
                    </table>
                  </v-col>
                </v-row>
              </v-card>

              <!-- FIRMAS -->
              <v-card max-width="792" height="auto" elevation="0">
                <v-row
                  class="ma-1"
                  style="
                    justify-content: space-between;
                    padding-left: 25px;
                    padding-right: 25px;
                  "
                >
                  <v-col cols="3.5">
                    <v-text-field hide-details></v-text-field>
                  </v-col>
                  <v-col cols="3.5">
                    <v-text-field hide-details></v-text-field>
                  </v-col>
                </v-row>
                <v-row
                  class="ma-1"
                  style="
                    justify-content: space-between;
                    padding-left: 25px;
                    padding-right: 25px;
                  "
                >
                  <v-col cols="3.5">
                    <div style="text-align: center">Firma de elaborado</div>
                  </v-col>
                  <v-col cols="3.5">
                    <div style="text-align: center">Firma recibido</div>
                  </v-col>
                </v-row>
              </v-card>

              <!-- seccion 2 -->
              <v-row class="ma-0 styleFecha">
                <v-col cols="auto"> COPIA </v-col>
              </v-row>
            </v-col>
          </section>
        </vue-html2pdf>
      </v-row>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";
import VueHtml2pdf from "vue-html2pdf";
import moment from "moment";

export default {
  data() {
    return {
      quedans: [],
      search: "",
      headers: [
        { text: "Opciones", align: "center", value: "action", sortable: false },
        {
          text: "N° Quedan",
          value: "correlativoQuedan",
          align: "left",
        },
        {
          text: "Fecha de emisión",
          value: "fechaEmision",
          align: "left",
        },
        {
          text: "Fecha de pago",
          value: "fechaPago",
          align: "left",
        },
        {
          text: "A favor de",
          value: "aFavorDe",
          align: "left",
        },
        {
          text: "NCR proveedor",
          value: "ncrProveedor",
          align: "left",
        },
        {
          text: "DUI proveedor",
          value: "duiProveedor",
          align: "left",
        },
        {
          text: "N° FAC",
          value: "nFac",
          align: "left",
        },
        {
          text: "Monto en dolares",
          value: "montoDolares",
          align: "left",
        },
      ],
      verNuevo: 0,
      verDet: 0,
      snackMensajeFechas: false,
      snackError: false,
      overlay: false,
      fechaInicio: "",
      fechaFin: "",
      idQuedan: "",
      idProveedor: "",
      correlativoQuedan: "",
      correlativoFolio: "",
      fechaEmision: "",
      fechaPago: "",
      aFavorDe: "",
      razonSocial: "",
      ncrProveedor: "",
      duiProveedor: "",
      nFac: "",
      nFac_1: "",
      nFac_2: "",
      nFac_3: "",
      montoDolares: 0,
      nombre_banco: "",
      numero_cuenta: 0,
      cantidadLetras: "",
      flag: true,
    };
  },
  components: {
    VueHtml2pdf,
  },
  created() {
    this.listarQuedans();
  },
  methods: {
    getVentaTotalFolio() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .get(
          `api/PagoProveedores/Total/${this.correlativoFolio}`,
          configuracion
        )
        .then((res) => {
          this.montoDolares = res.data;
        })
        .catch((err) => {
          this.montoDolares = 0.0;
          console.error(err);
        });
    },
    conversionNumero() {
      var lettet = this.numeroALetras(this.montoDolares, {
        plural: "dólares estadounidenses",
        singular: "dólar estadounidense",
        centPlural: "centavos",
        centSingular: "centavo",
      });
      this.cantidadLetras = lettet;
    },
    Unidades(num) {
      switch (num) {
        case 1:
          return "Un";
        case 2:
          return "Dos";
        case 3:
          return "Tres";
        case 4:
          return "Cuatro";
        case 5:
          return "Cinco";
        case 6:
          return "Seis";
        case 7:
          return "Siete";
        case 8:
          return "Ocho";
        case 9:
          return "Nueve";
      }

      return "";
    },
    Decenas(num) {
      let decena = Math.floor(num / 10);
      let unidad = num - decena * 10;

      switch (decena) {
        case 1:
          switch (unidad) {
            case 0:
              return "Diez";
            case 1:
              return "Once";
            case 2:
              return "Doce";
            case 3:
              return "Trece";
            case 4:
              return "Catorce";
            case 5:
              return "Quince";
            default:
              return "Dieci" + this.Unidades(unidad);
          }
        case 2:
          switch (unidad) {
            case 0:
              return "Veinte";
            default:
              return "Veinti" + this.Unidades(unidad);
          }
        case 3:
          return this.DecenasY("Treinta", unidad);
        case 4:
          return this.DecenasY("Cuarenta", unidad);
        case 5:
          return this.DecenasY("Cincuenta", unidad);
        case 6:
          return this.DecenasY("Sesenta", unidad);
        case 7:
          return this.DecenasY("Setenta", unidad);
        case 8:
          return this.DecenasY("Ochenta", unidad);
        case 9:
          return this.DecenasY("Noventa", unidad);
        case 0:
          return this.Unidades(unidad);
      }
    },
    DecenasY(strSin, numUnidades) {
      if (numUnidades > 0) return strSin + " Y " + this.Unidades(numUnidades);

      return strSin;
    },
    Centenas(num) {
      let centenas = Math.floor(num / 100);
      let decenas = num - centenas * 100;

      switch (centenas) {
        case 1:
          if (decenas > 0) return "Ciento " + this.Decenas(decenas);
          return "Cien";
        case 2:
          return "Doscientos " + this.Decenas(decenas);
        case 3:
          return "Trescientos " + this.Decenas(decenas);
        case 4:
          return "Cuatrocientos " + this.Decenas(decenas);
        case 5:
          return "Quinientos " + this.Decenas(decenas);
        case 6:
          return "Seiscientos " + this.Decenas(decenas);
        case 7:
          return "Setecientos " + this.Decenas(decenas);
        case 8:
          return "Ochocientos " + this.Decenas(decenas);
        case 9:
          return "Novecientos " + this.Decenas(decenas);
      }

      return this.Decenas(decenas);
    },
    Seccion(num, divisor, strSingular, strPlural) {
      let cientos = Math.floor(num / divisor);
      let resto = num - cientos * divisor;

      let letras = "";

      if (cientos > 0)
        if (cientos > 1) letras = this.Centenas(cientos) + " " + strPlural;
        else letras = strSingular;

      if (resto > 0) letras += "";

      return letras;
    },
    Miles(num) {
      let divisor = 1000;
      let cientos = Math.floor(num / divisor);
      let resto = num - cientos * divisor;

      let strMiles = this.Seccion(num, divisor, "Un Mil", "Mil");
      let strCentenas = this.Centenas(resto);

      if (strMiles == "") return strCentenas;

      return strMiles + " " + strCentenas;
    },
    millon(num, singular) {
      var letraMillon = "";
      if (singular == true) letraMillon = "Un millon";
      else letraMillon = "Millones";
      if (num % 1000000 == 0) letraMillon = letraMillon + " de";
      return letraMillon;
    },
    millones(num) {
      let divisor = 1000000;
      let cientos = Math.floor(num / divisor);
      let resto = num - cientos * divisor;

      let strMillones = this.Seccion(
        num,
        divisor,
        this.millon(num, true),
        this.millon(num, false)
      );
      let strMiles = this.Miles(resto);

      if (strMillones == "") return strMiles;

      return strMillones + " " + strMiles;
    },
    numeroALetras(num, currency) {
      let me = this;
      currency = currency || {};
      let data = {
        numero: num,
        enteros: Math.floor(num),
        centavos: Math.round(num * 100) - Math.floor(num) * 100,
        letrasCentavos: "",
        letrasMonedaPlural: currency.plural || "PESOS CHILENOS", //'PESOS', 'Dólares', 'Bolívares', 'etcs'
        letrasMonedaSingular: currency.singular || "PESO CHILENO", //'PESO', 'Dólar', 'Bolivar', 'etc'
        letrasMonedaCentavoPlural:
          currency.centPlural || "CHIQUI PESOS CHILENOS",
        letrasMonedaCentavoSingular:
          currency.centSingular || "CHIQUI PESO CHILENO",
      };

      if (data.centavos > 0) {
        data.letrasCentavos =
          "Con " +
          (function () {
            if (data.centavos == 1)
              return (
                me.millones(data.centavos) +
                " " +
                data.letrasMonedaCentavoSingular
              );
            else
              return (
                me.millones(data.centavos) +
                " " +
                data.letrasMonedaCentavoPlural
              );
          })();
      }

      if (data.enteros == 0)
        return "Cero " + data.letrasMonedaPlural + " " + data.letrasCentavos;
      if (data.enteros == 1)
        return (
          me.millones(data.enteros) +
          " " +
          data.letrasMonedaSingular +
          " " +
          data.letrasCentavos
        );
      else
        return (
          me.millones(data.enteros) +
          " " +
          data.letrasMonedaPlural +
          " " +
          data.letrasCentavos
        );
    },
    //******************************************************************************************************************** */
    VerNuevo() {
      this.verNuevo = 1;
      this.correlativo();
    },
    cerrarNuevo() {
      this.verNuevo = 0;
      this.verDet = 0;
      this.limpiar();
    },
    listarQuedans() {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      me.quedans = [];
      me.overlay = true;
      axios
        .get("api/FormQuedans/Listar", configuracion)
        .then(function (response) {
          me.quedans = response.data;
          me.overlay = false;
        })
        .catch(function (error) {
          console.log("Hubo un error", error);
          me.overlay = false;
          me.snackError = true;
        });
    },
    listarxFechas() {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      if (
        me.fechaInicio != "" &&
        me.fechaInicio != null &&
        me.fechaFin != "" &&
        me.fechaFin != null
      ) {
        me.quedansFechas = [];
        me.overlay = true;
        axios
          .get(
            "api/FormQuedans/FiltrarQuedans/" +
              me.fechaInicio +
              "/" +
              me.fechaFin,
            configuracion
          )
          .then(function (response) {
            me.quedans = response.data;
            me.overlay = false;
          })
          .catch(function (error) {
            console.log("Hubo un error", error);
            me.overlay = false;
            me.snackError = true;
          });
      } else {
        me.snackMensajeFechas = true;
      }
    },
    verDetalles(item) {
      this.flag = false;
      //SEPARANDO LOS NFAC
      var nFac = item.nFac.split(" ");

      this.idQuedan = item.idQuedan;
      this.idProveedor = item.idProveedor;
      this.correlativoQuedan = item.correlativoQuedan;
      this.correlativoFolio = item.correlativoFolio;
      this.fechaEmision = this.formatoFecha(item.fechaEmision);
      this.fechaPago = this.formatoFecha(item.fechaPago);
      this.aFavorDe = item.aFavorDe;
      this.razonSocial = item.razonSocial;
      this.nFac_1 = nFac[0];
      this.nFac_2 = nFac[1];
      this.nFac_3 = nFac[2];
      this.ncrProveedor = item.ncrProveedor;
      this.duiProveedor = item.duiProveedor;
      this.montoDolares = item.montoDolares;
      this.nombre_banco = item.nombre_banco;
      this.numero_cuenta = item.numero_cuenta;
      this.cantidadLetras = item.cantidadLetras;
      this.verNuevo = 1;
      this.verDet = 1;
    },
    limpiar() {
      this.verDet = 0;
      this.idQuedan = "";
      this.idProveedor = "";
      this.correlativoQuedan = "";
      this.correlativoFolio = "";
      this.fechaEmision = "";
      this.fechaPago = "";
      this.aFavorDe = "";
      this.razonSocial = "";
      this.nFac_1 = "";
      this.nFac_2 = "";
      this.nFac_3 = "";
      this.ncrProveedor = "";
      this.duiProveedor = "";
      this.montoDolares = 0;
      this.cantidadLetras = "";
      this.fechaInicio = "";
      this.fechaFin = "";
    },
    crearQuedan() {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      me.overlay = true;
      axios
        .post(
          "api/FormQuedans/Crear",
          {
            idProveedor: me.idProveedor,
            correlativoQuedan: me.correlativoQuedan,
            correlativoFolio: me.correlativoFolio,
            fechaEmision: me.fechaEmision,
            fechaPago: me.fechaPago,
            aFavorDe: me.aFavorDe,
            ncrProveedor: me.ncrProveedor,
            duiProveedor: me.duiProveedor,
            nFac: me.nFac_1 + " " + me.nFac_2 + " " + me.nFac_3,
            montoDolares: me.montoDolares,
            cantidadLetras: me.cantidadLetras,
            razonSocial: me.razonSocial,
            nombre_banco: me.nombre_banco,
            numero_cuenta: me.numero_cuenta,
          },
          configuracion
        )
        .then(function () {
          me.overlay = false;
          me.cerrarNuevo();
          me.listarQuedans();
        })
        .catch(function (error) {
          console.log("hubo algún error", error);
          me.overlay = false;
          me.snackError = true;
        });
    },
    actualizarQuedan() {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      me.overlay = true;
      axios
        .put(
          "api/FormQuedans/Actualizar",
          {
            idQuedan: me.idQuedan,
            idProveedor: me.idProveedor,
            correlativoQuedan: me.correlativoQuedan,
            correlativoFolio: me.correlativoFolio,
            fechaEmision: me.fechaEmision,
            fechaPago: me.fechaPago,
            aFavorDe: me.aFavorDe,
            ncrProveedor: me.ncrProveedor,
            duiProveedor: me.duiProveedor,
            nFac: me.nFac_1 + " " + me.nFac_2 + " " + me.nFac_3,
            montoDolares: me.montoDolares,
            cantidadLetras: me.cantidadLetras,
            razonSocial: me.razonSocial,
            nombre_banco: me.nombre_banco,
            numero_cuenta: me.numero_cuenta,
          },
          configuracion
        )
        .then(function () {
          me.overlay = false;
          me.cerrarNuevo();
          me.listarQuedans();
        })
        .catch(function (error) {
          console.log("Hubo un error", error);
          me.overlay = false;
          me.snackError = true;
        });
    },
    imprimir() {
      this.$refs.html2Pdf.generatePdf();
    },
    infoproveedores() {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      me.overlay = true;
      axios
        .get(
          "api/DetallexProveedores/ListarDui/" + me.duiProveedor,
          configuracion
        )
        .then(function (response) {
          if (response.data.length > 0) {
            me.aFavorDe = response.data[0].nombre;
            me.idProveedor = response.data[0].idProveedor;
            me.ncrProveedor = response.data[0].ncr;
            me.razonSocial = response.data[0].razonSocial;
            me.nombre_banco = response.data[0].nombre_banco;
            me.numero_cuenta = response.data[0].numero_cuenta;
          }
          me.overlay = false;
        })
        .catch(function (error) {
          console.log("Hubo un error", error);
          me.overlay = false;
          me.snackError = true;
        });
    },
    correlativo() {
      if (this.quedans.length >= 1 && this.quedans.length < 9) {
        this.correlativoQuedan = "0000" + (this.quedans.length + 1);
      } else if (this.quedans.length >= 9 && this.quedans.length < 99) {
        this.correlativoQuedan = "000" + (this.quedans.length + 1);
      } else if (this.quedans.length >= 99 && this.quedans.length < 999) {
        this.correlativoQuedan = "00" + (this.quedans.length + 1);
      } else if (this.quedans.length >= 999 && this.quedans.length < 9999) {
        this.correlativoQuedan = "0" + (this.quedans.length + 1);
      } else if (this.quedans.length >= 9999) {
        this.correlativoQuedan = this.quedans.length + 1;
      }
    },
    formatoFecha(fecha) {
      return moment(fecha).format("YYYY/MM/DD HH:mm");
    },
  },
};
</script>

<style scoped>
.textContactoNombre {
  padding-right: 0px;
  padding-left: 2px;
  padding-bottom: 0px;
  padding-top: 18px;
  z-index: 2;
  font-weight: bold;
  font-size: 14px;
}
.textContactoDireccionTelefono {
  padding-right: 0px;
  padding-left: 2px;
  padding-bottom: 0px;
  padding-top: 0px;
  z-index: 2;
  font-size: 15px;
}
.table_1 {
  width: 100%;
  border-collapse: collapse;
}
.table_1 th {
  font-weight: bold;
  border: 1px solid black;
  padding: 3px;
}
.table_1 td {
  font-weight: 400;
  border: 1px solid black;
  padding: 3px;
}
.table_2 {
  width: 100%;
  border-collapse: collapse;
}
.table_2 th {
  font-weight: 500;
  border: 1px solid black;
  padding-right: 8px;
  padding-left: 8px;
  white-space: nowrap;
}
.table_2 td {
  font-weight: 400;
  border: 1px solid black;
  padding: 2px;
}
.styleFecha {
  padding-top: 0px;
  padding-right: 70px;
  justify-content: flex-end;
  color: red;
}
.textFieldStyle >>> .v-input__slot::before {
  border-style: none !important;
}
</style>